<template>
  <div class="body">
    <div class="model">
      <div>邀请加入此项目，并为其分配权限</div>
      <div class="limit-num">
        <div>限制人数</div>
        <div>
          <el-select v-model="form.maxPeople" class="select" style="width: 70px">
            <el-option label="5" value="5" />
            <el-option label="10" value="10" />
            <el-option label="20" value="20" />
            <el-option label="50" value="50" />
            <el-option label="不限制" value="999" />
          </el-select>
          人
        </div>
      </div>
      <div class="limit-time">
        <div>链接有效期</div>
        <div>
          <el-select v-model="form.expiryDate" class="select" style="width: 70px">
            <el-option label="1" value="1" />
            <el-option label="3" value="3" />
            <el-option label="7" value="7" />
            <el-option label="14" value="14" />
            <el-option label="30" value="30" />
          </el-select>
        </div>
        天
      </div>
    </div>
    <div class="option">
      邀请人员加入项目后，其权限为
      <el-select v-model="form.permissionLevel" class="select">
        <el-option label="可查看" value="0">
          <span style="font-weight: 600">可查看</span>
          <span style="font-size: 14px; color: #666666">（可查看项目内容，但无法编辑）</span>
        </el-option>
        <el-option label="可编辑" value="1">
          <span style="font-weight: 600">可编辑</span>
          <span style="font-size: 14px; color: #666666">（可查看项目内容，可编辑）</span>
        </el-option>
        <el-option label="管理员" value="2">
          <span style="font-weight: 600">管理员</span>
          <span style="font-size: 14px; color: #666666">（可查看项目内容，可编辑，可管理项目成员）</span>
        </el-option>
      </el-select>
      <div style="margin-left: 40px">
        <el-button size="small" type="primary" @click="shareInfo">复制链接</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  shareProject
} from '@/api/merchant/service/project'

export default {
  name: 'ProjectListItem',
  components: {},
  props: {
    id: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      info: null,
      form: {
        maxPeople: 5,
        expiryDate: 14,
        permissionLevel: '0'
      }
    }
  },
  watch: {
    id: {
      handler: function (val, oldVal) {},
      deep: true
    }
  },
  created () {},
  mounted () {},
  methods: {
    shareInfo () {
      let that = this
      this.form.projectId = this.id
      shareProject(this.form).then((res) => {
        let info = res
        // 复制链接到剪切板
        let text = `${info.shareUrl}\n邀请你加入「${info.projectName}」项目  未来船票｜云团队\n有效期：${info.expiryDate}`
        navigator.clipboard.writeText(text).then(
          function (e) {
            that.$message({
              message: '已复制分享链接，发送给对方即可邀请加入项目',
              type: 'success'
            })
          },
          function (e) {
            console.log('复制失败,请重试', e)
            that.$message({
              message: '复制失败,请重试',
              type: 'error'
            })
          }
        )
      })
    },
    copyToClipboard (textToCopy) {
      // navigator clipboard 需要https等安全上下文
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        return navigator.clipboard.writeText(textToCopy)
      } else {
        // 创建text area
        let textArea = document.createElement('textarea')
        textArea.value = textToCopy
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? res() : rej()
          textArea.remove()
        })
      }
    }
  }

}
</script>

<style scoped lang="scss">
  .body {
    padding: 0 10px;
  }
  .model {
    color: #1f2126;
    font-size: 14px;
    font-weight: 500;
    background-color: #f5f7fa;
    border-radius: 6px;
    padding: 20px 10px 20px 10px;
  }
  .limit-num {
    margin-top: 20px;
    display: flex;
    font-size: 12px;
    color: #666666;
    padding-left: 10px;
    align-items: center;
  }
  .limit-time {
    margin-top: 10px;
    display: flex;
    font-size: 12px;
    color: #666666;
    padding-left: 10px;
    align-items: center;
  }
  .select {
    width: 100px;
    height: 40px;
    margin-left: 10px;
    margin-right: 5px;
    .el-input__inner {
      padding: 0;
      border: 0 !important;
    }
  }
  .option {
    padding-left: 10px;
    display: flex;
    margin-top: 10px;
    align-items: center;
    line-height: 40px;
  }
</style>
